'use client';

import { BottomNav as ChromeBottomNav } from '@/components/chrome/bottom-nav';
import { NAVIGATION } from '@/lib/navigation';

/**
 * Bottom navigation — thin wrapper around the registry-installed chrome
 * bottom bar. Site config lives here; rendering in @/components/chrome/bottom-nav.
 */
export function BottomNav() {
  return <ChromeBottomNav items={NAVIGATION.bottom} />;
}
